import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Polyline, CircleMarker } from "react-leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import { URL_BASE } from "../../config/url-server";

const Track = () => {
    const [tracks, setTracks] = useState([]);

    const clientId = localStorage.getItem("client")
    const accessToken = localStorage.getItem("token")

    useEffect(() => {
        const fetchTracks = async () => {
            try {
                const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
                const response = await axios.get(URL_BASE+"tracking/list", config);
                setTracks(response.data.data);
            } catch (error) {
                console.error("Error obteniendo los tracks:", error);
            }
        };

        fetchTracks();
    }, []);

    // Función para generar un color aleatorio
    const getRandomColor = () => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    return (
        <MapContainer
            style={{ height: "100vh", width: "100%" }}
            center={[11.226374, -74.168345]} // Centrar en coordenadas iniciales
            zoom={17} // Ajustar zoom inicial
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {tracks.map((track, index) => {
                const color = getRandomColor(); // Color único para cada track
                const polylinePoints = track.movements.map(movement => [
                    movement.location.coordinates[1], // Latitud
                    movement.location.coordinates[0], // Longitud
                ]);

                return (
                    <React.Fragment key={index}>
                        {/* Dibujar la polyline */}
                        <Polyline positions={polylinePoints} color={color} />

                        {/* Dibujar marcadores pequeños en los puntos */}
                        {polylinePoints.map((point, i) => (
                            <CircleMarker
                                key={i}
                                center={point}
                                radius={1} // Marcadores pequeños
                                color={color}
                            />
                        ))}
                    </React.Fragment>
                );
            })}
        </MapContainer>
    );
};

export default Track;